export enum FieldEnum {
  patrimony = 'patrimony',
  annualInvestment = 'annualInvestment',
  nbYears = 'nbYears',
  stockYield = 'stockYield',
  yieldOther = 'yieldOther',
  stockTax = 'stockTax',
  tax = 'tax',
  withdrawalRate = 'withdrawalRate',
  inflationRate = 'inflationRate',
  allowance = 'allowance',
  investAllowance = 'investAllowance',
}

export interface FormValues {
  [FieldEnum.patrimony]: number | undefined;
  [FieldEnum.allowance]: number | undefined;
  [FieldEnum.annualInvestment]: number | undefined;
  [FieldEnum.nbYears]: number | undefined;
  [FieldEnum.stockYield]: number | undefined;
  [FieldEnum.yieldOther]: number | undefined;
  [FieldEnum.stockTax]: number | undefined;
  [FieldEnum.tax]: number | undefined;
  [FieldEnum.withdrawalRate]: number | undefined;
  [FieldEnum.inflationRate]: number | undefined;
  [FieldEnum.investAllowance]: number | undefined;
}

export type GraphData = {
  initialPatrimony: number;
  netValue: number;
  investment: number;
  year: number;
}[];

export type UseWealthSimulatorCalculation = (props: FormValues) => {
  futurCapital: number;
  addedValue: number;
  netValue: number;
  monthlyRevenue: number;
  graphData: GraphData;
  isInvalid?: boolean;
};

export type GetSimulation = (
  initialPatrimony: number,
  nbYears: number,
  annualInvestment: number,
  yieldValue: number,
  inflationRate: number,
  tax: number,
  compoundsPerYear?: number,
) => {
  futurCapital: number;
  addedValue: number;
  netValue: number;
  isInterestRateInvalid?: boolean;
};
